import React from "react";
import { Form } from "react-bootstrap";
import { FormHelper } from "utils";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";

export default function ConfiguracionUsuariosTab({
  compania,
  setCompania,
  setCheckedProp,
}) {
  return (
    <div className="px-3 pb-4">
      <EditSection title="Política de Contraseña" style={{}}>
        <SectionRow>
          <InputContainer label="Cantidad Mínima Cáracteres Contraseña" labelSize={4}>
            <Form.Control
              name="CantidadMinimaCaracteres"
              type="number"
              min={0}
              placeholder="0"
              onChange={(e) => FormHelper.handleChangeNumero(e, setCompania)}
              value={compania.CantidadMinimaCaracteres || ""}
              style={{ maxWidth: 120 }}
            />
            <Form.Text className="text-muted">Cero no hay mínimo</Form.Text>
          </InputContainer>
        </SectionRow>

        <SectionRow>
          <InputContainer label="Usa mayúsculas" labelSize={4}>
            <Form.Check
              type="switch"
              id="swUsaMayusculas"
              name="UsaMayusculas"
              checked={compania.UsaMayusculas ?? false}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>

        <SectionRow>
          <InputContainer label="Usa letras y números" labelSize={4}>
            <Form.Check
              type="switch"
              id="swUsaAlfaNumerico"
              name="UsaAlfaNumerico"
              checked={compania.UsaAlfaNumerico ?? false}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>

        <SectionRow>
          <InputContainer label="Usa Cáracteres Especiales" labelSize={4}>
            <Form.Check
              type="switch"
              id="swUsaCaracteresEspeciales"
              name="UsaCaracteresEspeciales"
              checked={compania.UsaCaracteresEspeciales ?? false}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>

        <SectionRow>
          <InputContainer label="Forzar cambio de contraseña" labelSize={4}>
            <Form.Check
              type="switch"
              id="swCambioPassword"
              name="CambioPassword"
              checked={compania.CambioPassword ?? false}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>

        {compania.CambioPassword && (
          <SectionRow>
            <InputContainer label="Tiempo de Cambio Contraseña" labelSize={4}>
              <Form.Control
                name="FechaCambioPassword"
                type="number"
                min={0}
                placeholder="0"
                onChange={(e) => FormHelper.handleChangeNumero(e, setCompania)}
                value={compania.FechaCambioPassword || ""}
                style={{ maxWidth: 120 }}
              />
              <Form.Text className="text-muted">
                Días
              </Form.Text>
            </InputContainer>
          </SectionRow>
        )}

        <SectionRow>
          <InputContainer label="Cambiar contraseña en el primer inicio de sesión" labelSize={4}>
            <Form.Check
              type="switch"
              id="swCambiarPrimeraContrasenia"
              name="CambiarPrimeraContrasenia"
              checked={compania.CambiarPrimeraContrasenia ?? false}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>
      </EditSection>

      <EditSection title="Bloqueo de Usuario" style={{}}>
        <SectionRow>
          <InputContainer label="Bloquear usuario por intentos fallidos" labelSize={4}>
            <Form.Check
              type="switch"
              id="swBloqueoUsuario"
              name="BloqueoUsuario"
              checked={compania.BloqueoUsuario ?? false}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>

        {compania.BloqueoUsuario && (
          <SectionRow>
            <InputContainer label="Cantidad de intentos" labelSize={4}>
              <Form.Control
                name="Intentos"
                type="number"
                min={0}
                placeholder="0"
                onChange={(e) => FormHelper.handleChangeNumero(e, setCompania)}
                value={compania.Intentos || ""}
                style={{ maxWidth: 120 }}
              />
            </InputContainer>
          </SectionRow>
        )}
      </EditSection>

      <EditSection title="Sesión" style={{}}>
        <SectionRow>
          <InputContainer label="Usar Cierre de Sesión por inactividad" labelSize={4}>
            <Form.Check
              type="switch"
              id="swUsaCierreSesionInactividad"
              name="UsaCierreSesionInactividad"
              checked={compania.UsaCierreSesionInactividad ?? false}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>

        {compania.UsaCierreSesionInactividad && (
          <SectionRow>
            <InputContainer label="Tiempo de inactividad" labelSize={4}>
              <Form.Control
                name="TiempoEsperaInactividadMinutos"
                type="number"
                min={0}
                placeholder="0"
                onChange={(e) => FormHelper.handleChangeNumero(e, setCompania)}
                value={compania.TiempoEsperaInactividadMinutos || ""}
                style={{ maxWidth: 120 }}
              />
              <Form.Text className="text-muted">
                Minutos
              </Form.Text>
            </InputContainer>
          </SectionRow>
        )}
      </EditSection>

      <EditSection title="Autenticación de Dos Factores" style={{}}>
        <SectionRow>
          <InputContainer label="Requerir verificación por correo" labelSize={4}>
            <Form.Check
              type="switch"
              id="swDobleFactorAutenticacion"
              name="DobleFactorAutenticacion"
              checked={compania.DobleFactorAutenticacion ?? false}
              onChange={setCheckedProp}
              label=""
            />
            <Form.Text className="text-muted">
              Envía un código de 5 dígitos al correo del usuario al iniciar sesión
            </Form.Text>
          </InputContainer>
        </SectionRow>
      </EditSection>
    </div>
  );
}
